<template>
<div>
 <div class="row">
    <app-overlay-loader v-if="preloader" />
    <div class="col-sm-4 col-md-3" v-for="(docx , index) in documents" :key="index" v-if="docx.file">
      <div class="card-body" style="padding: 1rem;">
        <div class="card card-with-shadow border-0 ">
          <div class="card-body text-center " :class="{ 'active_border' : active_el == index }"  @click="getFilePath(docx.file.path , index , docx.name, docx.expiry_date, docx.file.id )" style="border: 2px solid transparent;">
            <span>
              <app-icon name="file"/>
            </span>
            <h6 class="mt-primary text-center mb-0"> {{ docx.name }} </h6>
            <small>Expiry: {{ docx.expiry_date }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-sm-12 my-4 py-4" >
       <button class="btn btn-primary" @click.prevent="getUpdateFielPathState"  > Submit </button>
    </div>
  </div> -->
</div>
 
</template>

<script>
import { DOCUMENT_GALLERY } from "../../../../Config/ApiUrl";
import {axiosGet, axiosPost} from "../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../Helpers/AppLibrary";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  name: "FileGallery",
  extends: AppLibrary,
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      documents: [],
      path: {},
      isActive: false,
      active_el: null, 
    };
  },
  methods: {
    getDocument() {
      let data={
        guestUser:this.$store.state.sharedData?.sharedData.guestUserData??{},
      }
      axiosPost(DOCUMENT_GALLERY, data)
        .then((response) => {
          //   
          this.documents = response.data;
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getFilePath(path , id , name ,expiry, fileId){
      // 
      let componentId = this.$attrs['props'].componentId;
     
      this.path = path ;
      const data =
      [{
        id : fileId,
        name : name,
        path : path,
        expiry : expiry,
        component_id : componentId,
       }]; 
      // data = path
      //  
      
       this.$store.dispatch("setValueToPassFile", { data, componentId, id }) ;
      // this.$store.state.uploadFilePath.dataUploadFilePath[id] = path ;
      // this.isActive = !this.isActive;
      this.active_el = id;
      
      // let file = JSON.stringify(data);
      // let file = JSON.stringify(data, null, "\t");
      let file = JSON.stringify(this.$store.state.uploadFilePath.dataUploadFilePath[componentId]);
      this.$attrs['props'].Func(file);
      
      // this.$attrs['props'].Func(data);
      // this.$emit('changeTitle', path);
  
    },
  //   getUpdateFielPathState(){
  //     
  //     this.$attrs['props'].fun();
  //     // debugger
  //     // return  this.$store.state.uploadFilePath.dataUploadFilePath ;
  //  },
  },
  
  mounted() {
    this.getDocument();
  },
};
</script>

<style >
 .active_border{
   cursor: pointer;
   border: 2px solid #4466f2 !important;
    /* border: 5px dashed transparent; */
 }
 /* .active_border:focus-within , .active_border:focus , .active_border:active , .active_border:target , .active_border:focus-visible {
    border: 2px solid #4466f2 !important;
 } */
</style>
